import { useEffect, useState } from 'react';

const SLIDEOUT_FULLSCREEN_STORAGE_KEY = 'slideoutFullScreen';

/**
 * Fullscreen toggle for the slideout panel, persisted in localStorage.
 * Extracted from SlideOutPanel/index.tsx (Part 1 modularisation).
 */
export function useSlideoutFullscreen() {
  const [isFullScreen, setIsFullScreen] = useState(() => {
    try {
      const storedValue = localStorage.getItem(SLIDEOUT_FULLSCREEN_STORAGE_KEY);
      return storedValue === 'true';
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(
        SLIDEOUT_FULLSCREEN_STORAGE_KEY,
        String(isFullScreen)
      );
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
  }, [isFullScreen]);

  return { isFullScreen, setIsFullScreen };
}
